<!-- 
    User Access
-->
<template>

<div class="row">

    <div v-if='isReady && user.type == 2' class="col-12">

        <div class="row">

            <div v-for='r in roles' v-if='model' class='col-12 col-md-6 col-lg-3 mb-3'>

                <h6 class="fieldset-subtitle">{{ r.name }}</h6>

                <div v-if v-for='i in r.items'>
                    <div class="custom-control custom-checkbox mb-2">
                        <input type="checkbox" 
                            name="" v-model='model[ i.id ]'
                            class="custom-control-input"
                            :id="'role-' + i.id">
                            
                        <label :for="'role-' + i.id" class="custom-control-label">
                            {{ i.name }}
                        </label>
                    </div>
                </div>

            </div>

            <div class='col-12 text-center'>
                <button @click='save' class='btn btn-success btn-lg mt-2' :disabled='isLoading'>
                    <span class="icon icon-save"></span>
                    Запази
                </button>
            </div>

        </div>                            

    </div>

    <div v-if='user.type == 1' class="col-12">
        <div class='alert alert-info'>
            Избрали сте, че ролята ви в Видеа е на възложител. 
            За да достъпите тази секция, моля изберете, че искате да станете изпълнител от  
            <router-link to='/profile'>вашия профил</router-link>.
        </div>
    </div>
    
</div>

</template>

<script>
    export default {

        mounted() {
            this.getData();
        },

        created() {

        },

        data() {
            return {
                isReady     : false,
                isLoading   : false,
                roles       : [],
                userRoles   : [],

                model : false
            }
        },

        methods : {
            getData() {
                var me = this;

                me.ajax.call('usr:gr', {} , (r) => {
                    
                    me.isReady = true;

                    if( r.status == 'success' ) {

                        me.roles = r.data.roles;
                        me.userRoles = r.data.user_roles;

                        me.buildModel();

                    }

                })
            },

            buildModel() {

                var mdl = {};

                for( var i in this.roles ) {

                    for( var j in this.roles[i].items ) {

                        if( this.userRoles.includes( this.roles[i].items[j].id ) ) {

                            mdl[ this.roles[i].items[j].id ] = true;

                        } else {

                            mdl[ this.roles[i].items[j].id ] = false;

                        }

                    }

                }

                this.model = mdl;

            },

            save() {

                var me = this,
                    data = {
                        items : this.model
                    };

                this.isLoading = true;

                me.ajax.call('usr:sr', data, (r) => {

                    this.isLoading = false;

                    if( r.status == 'success' ) {

                        me.notify('save-success');

                    }

                })

            }
        },

        watch : {
           
        }

    }
</script>
